import React, {useContext} from 'react';
import {Maybe} from 'monet';
import * as R from 'ramda';
import {Row, Col} from 'reactstrap';
import {useFixedTranslation} from '@/i18n';
import Select from '@/Form/Select';
import Icon from '@/views/shared/Icon';
import DownloadFileButton from '@/views/shared/DownloadFileButton';

import {PolicyStatementCtx} from '@/b2b/contexts';
import {getCurrentPolicy} from '@/b2b/pages/PolicyStatement/state';

const SelectCurrency = () => {
  const [state, dispatch] = useContext(PolicyStatementCtx);
  const {currency, partyId: clientId, statementLanguage} = state;
  const currentPolicy = getCurrentPolicy(state);
  const tr = useFixedTranslation(statementLanguage, 'statement');
  const options = R.propOr([], 'consolidateCurency', currentPolicy);
  const buildSelectOptions = R.map(([key, val]) => (
    <option value={val} key={val}>
      {key}
    </option>
  ));

  const onChangeCurrency = e => {
    const selectedCurrency = e.currentTarget.value;
    dispatch({type: 'changeCurrency', payload: {selectedCurrency}});
  };

  const downloadPath = `/statement/consolidate_statement/${clientId}.pdf?selected_currency=${currency}`;

  const Content = () => (
    <>
      <Row>
        <Col md='auto' className='pr-1 pt-1'>
          {tr('choose_currency')}
        </Col>
        <Col md={2} className='px-0'>
          <Select
            name='selectedCurrency'
            onChange={onChangeCurrency}
            value={currency}
          >
            {buildSelectOptions(options)}
          </Select>
        </Col>
        <Col md={2} className='pl-1 pt-1'>
          <small>{tr('pdf_version')}</small>
          <DownloadFileButton
            className='btn btn-link btn-sm'
            path={downloadPath}
          >
            <Icon icon='file-pdf' />{' '}
          </DownloadFileButton>
        </Col>
      </Row>
    </>
  );

  return Maybe.fromFalsy(currentPolicy.accountType === 'CONSOLIDATE')
    .map(() => <Content />)
    .orNull();
};

export default SelectCurrency;
